import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  isOfferFailed,
  isOfferSuccessfull,
  LouiseOffer,
} from '../../../../../types/Quotes';
import { toEuro } from '../../utils/stringUtils';
import InsuranceCompanyLogo from '../../../../common/src/components/InsuranceCompanyLogo';
import { Skeleton, Text, VStack, Box } from '@wegroup/design-system';
import { getGuaranteeNameForKey } from '../../services/productFactoryService';
import OfferLogoWrapper from '../default/OfferLogoWrapper';
import SingleOfferErrorMessage from './SingleOfferErrorMessage';
import { useLouiseSelector } from '../../store/redux/store';

interface Props {
  offer: LouiseOffer;
}

const SingleOfferHeaderMobile: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
}) => {
  const { t } = useTranslation();
  const shownProductsAmount = useLouiseSelector(
    (state) => state.offers.shownProductIds[offer.info.insurance_type]?.length,
  );
  return (
    <Header>
      <OfferLogoWrapper>
        <InsuranceCompanyLogo insuranceCompany={offer.info.company.key} />
      </OfferLogoWrapper>
      <div>
        {isOfferFailed(offer) ? (
          <SingleOfferErrorMessage offer={offer} />
        ) : isOfferSuccessfull(offer) ? (
          <>
            <Box mb="2">
              <Text textStyle="normalBodyBold">
                {offer.info.company.name || t('Insurer')}{' '}
              </Text>
              <Text textStyle="smallBody" color="text.gray">
                {getGuaranteeNameForKey(
                  offer.info.insurance_name,
                  offer.guarantee_content,
                )}
              </Text>
            </Box>
            <Price>
              <span>{toEuro(offer.premium.total_premium)}</span>/
              {t(offer.premium.payment_interval.toUpperCase())}
            </Price>
            <Match>
              {offer.matching_score && shownProductsAmount > 1 && (
                <>
                  <span>{offer.matching_score.toFixed(2)}%</span> {t('match')}
                </>
              )}
            </Match>
          </>
        ) : (
          <VStack spacing="2" align="stretch">
            <Skeleton h="5" maxW="60" />
            <Skeleton h="5" maxW="32" />
            <Skeleton h="5" maxW="28" />
          </VStack>
        )}
      </div>
    </Header>
  );
};

const Match = styled.p`
  color: ${({ theme }) => theme.labels.guaranteeText};
  > span {
    color: ${({ theme }) => theme.status.succes};
    font-weight: 500;
  }
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 1.6rem;
  align-items: center;
  padding: 1.6rem;
  min-height: 120px;
`;

const Price = styled.div`
  color: ${({ theme }) => theme.labels.guaranteeText};
  font-size: 1.4rem;
  margin-bottom: 0.4rem;

  > span {
    color: ${({ theme }) => theme.typo.title};
    font-weight: 500;
  }
`;

export default SingleOfferHeaderMobile;
